/**
 * Central tournament configuration.
 *
 * To switch tournaments (e.g. IPL → T20 WC), change these values
 * and provide a matching schedule JSON in public/data/.
 *
 * Every file that previously hardcoded tournament-specific values
 * now imports from here.
 */
export const CURRENT_TOURNAMENT = {
  id: "ipl_2026",
  name: "Indian Premier League 2026",
  shortName: "IPL",
  matchIdPrefix: "ipl_m",
  dataFile: "/data/ipl_2026.json",
  fallbackDateRange: "28 Mar \u2013 31 May 2026",
  stages: [
    { key: "League", label: "League Stage" },
    { key: "Qualifier1", label: "Qualifier 1" },
    { key: "Eliminator", label: "Eliminator" },
    { key: "Qualifier2", label: "Qualifier 2" },
    { key: "Final", label: "Final" },
  ],
};
